module.exports = __webpack_public_path__ + "static/fonts/CenturyGothic-Regular.4bb8ff5.woff";